import { fromFilterUrlParameter } from 'src/core/common/components/FilterBuilder';

export type PayableDateRange = {
  from: string;
  to: string;
};

/**
 * Extracts a yyyy-MM-dd date range from a payableFilter string.
 *
 * Expected pattern (unencoded):
 * - payableDate|isBetween|from:2025-01-01;to:2025-01-31
 */
export const extractPayableDateRangeFromPayableFilter = (
  payableFilter: string | null | undefined,
): PayableDateRange | null => {
  if (!payableFilter) {
    return null;
  }

  const parsed = fromFilterUrlParameter(payableFilter, [
    { key: 'payableDate', label: 'Payable date', kind: 'date' },
  ]);

  const payableDateSubfilter = parsed?.filter.subfilters
    .flatMap((group) => group.subfilters)
    .find(
      (subfilter) =>
        subfilter.field === 'payableDate' && subfilter.operator === 'isBetween',
    );

  const value = payableDateSubfilter?.value;
  if (!value || typeof value !== 'object') {
    return null;
  }

  const from =
    'from' in value && value.from instanceof Date ? value.from : null;
  const to = 'to' in value && value.to instanceof Date ? value.to : null;

  if (!from || !to) {
    return null;
  }

  return {
    from: from.toISOString().slice(0, 10),
    to: to.toISOString().slice(0, 10),
  };
};
